<template>
  <div>
    <div>
      <!-- {{ hasPendency }} -->
      <!-- {{ checklistValue.id }} -->
      <!-- {{checklistValue}} -->
      <b-row v-if="checklistValue.fieldType == 8">
        <b-col>
          <label>
            <span style="white-space: pre">
              {{ checklistValue.value }}
            </span>
          </label>
        </b-col>
        <b-col v-if="checklistValue.hasOpenPending">
          <span><i class="tim-icons icon-alert-circle-exc"></i></span>
        </b-col>
      </b-row>

      <div v-else>
        <b-row>
          <b-col cols="5" v-if="checklistValue.hasOpenPending">
            <label :for="'input' + checklistValue.id.toString()">
              {{ getLabel }}
              <a
                href="#"
                @click="openPendencyModal(checklistValue.id, getLabel)"
              >
                <i class="danger tim-icons icon-alert-circle-exc"></i>
              </a>
            </label>
          </b-col>
          <b-col cols="5" v-else>
            <label for="">{{ getLabel }}</label>
          </b-col>

          <b-col>
            <b-input-group
              v-if="
                checklistValue.fieldType == 10 || checklistValue.fieldType == 11
              "
            >
              <div v-if="checklistValue.hasAttachment">
                <b-button
                  v-if="!isShowingAttachment"
                  size="sm"
                  @click="showAttachment()"
                >
                  {{ $t("geral.showAttachments") }}
                </b-button>
                <b-button
                  v-if="isShowingAttachment"
                  size="sm"
                  @click="hideAttachment()"
                >
                  {{ $t("geral.hideAttachments") }}
                </b-button>
              </div>
            </b-input-group>

            <b-input-group v-else>
              <!-- Booleano -->
              <b-form-select
                v-if="checklistValue.fieldType == 1"
                class="hasPendency"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                :name="'input' + checklistValue.id.toString()"
                value="true"
                unchecked-value="false"
                disabled
                :options="optionsBoolean"
              ></b-form-select>

              <!-- Data -->
              <b-form-input
                v-else-if="checklistValue.fieldType == 2"
                class="hasPendency"
                type="date"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              />

              <!-- Hora -->
              <b-form-input
                v-else-if="checklistValue.fieldType == 3"
                class="hasPendency"
                type="time"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              />

              <!-- Decimal -->
              <b-form-input
                v-else-if="checklistValue.fieldType == 4"
                class="hasPendency"
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                v-mask="'money'"
                readonly
              />

              <!-- Inteiro -->
              <b-form-input
                v-else-if="checklistValue.fieldType == 5"
                class="hasPendency"
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                v-mask="'999999999999999'"
                readonly
              />

              <!-- Texto -->
              <b-form-input
                v-else-if="checklistValue.fieldType == 6"
                class="hasPendency"
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              />

              <!-- Lista -->

              <b-form-input
                v-else-if="checklistValue.fieldType == 7"
                type="text"
                class="hasPendency"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.formatedValue"
                readonly
              />

              <b-form-input
                v-else-if="checklistValue.fieldType == 9"
                class="hasPendency"
                type="text"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              />

              <b-form-input
                v-else
                type="text"
                class="hasPendency"
                :id="'input' + checklistValue.id.toString()"
                v-model="checklistValue.value"
                readonly
              />

              <b-input-group-append v-if="checklistValue.hasAttachment">
                <b-button v-if="!isShowingAttachment" @click="showAttachment">
                  <i class="tim-icons icon-attach-87"></i>
                </b-button>
                <b-button v-if="isShowingAttachment" @click="hideAttachment">
                  <i class="tim-icons icon-attach-87"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </div>
      <!-- </b-form-group> -->

      <b-tooltip
        v-if="checklistValue.formatedValue != ''"
        :target="'input' + checklistValue.id.toString()"
        triggers="hover"
      >
        {{ checklistValue.formatedValue }}
      </b-tooltip>
      <b-tooltip
        v-else
        :target="'input' + checklistValue.id.toString()"
        triggers="hover"
      >
        {{ checklistValue.value }}
      </b-tooltip>
    </div>
    <div>
      <b-row class="imagem" v-if="isShowingAttachment">
        <b-col
          md="6"
          v-for="(attachment, rowAttachment) in checklistValue.attachments"
          :key="rowAttachment"
        >
          <!-- {{attachment}} -->
          <base-attachment-viewer
            class="ml-3 mb-3"
            :attachment="attachment"
            :discard-visible="false"
            :attachmentNumber="rowAttachment + 1"
            @discard="fileRemove"
          ></base-attachment-viewer>
        </b-col>
      </b-row>
    </div>
    <pendency-modal
      ref="pendencyModal"
      @approvalPendency="approvalPendency"
    ></pendency-modal>
  </div>
</template>
<script>
import AwesomeMask from "awesome-mask";
import BaseAttachmentViewer from "@/components_rms/base/BaseAttachmentViewer.vue";

export default {
  name: "FilledDetailsPendency",
  props: {
    checklistValue: Object,
    label: String,
  },
  components: {
    BaseAttachmentViewer,
    PendencyModal: () =>
      import("@/components_rms/checklist/pendency/PendencyModal.vue"),
  },
  directives: {
    mask: AwesomeMask,
  },
  data: function () {
    return {
      fullscreenAttachment: "",
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      isShowingAttachment: false,
    };
  },
  created: function () {},
  computed: {
    getLabel() {
      if (this.label && this.label.length > 0) return this.label;
      if (this.checklistValue) return this.checklistValue.fieldName;
      return ";";
    },
  },
  methods: {
    approvalPendency() {
      this.checklistValue.hasOpenPending = false;
    },
    openPendencyModal(valueId, fieldName) {
      this.$refs.pendencyModal.show(valueId, fieldName);
    },
    hideAttachment() {
      if (!this.checklistValue) return;
      if (!this.checklistValue.hasAttachment) return;
      this.isShowingAttachment = false;
      this.$emit("after-attachment-show");
    },
    showAttachment() {
      if (!this.checklistValue) return;
      if (!this.checklistValue.hasAttachment) return;

      this.isShowingAttachment = true;
      this.$emit("after-attachment-show");

      if (!this.isShowingAttachment) return;
      // if (this.checklistValue.attachment) return;
      //    /checklist/attachment/{attachmentId}

      this.checklistValue.attachments.forEach((ckAttach) => {
        if (!ckAttach.attachment) {
          let urlAttachment;
          if (ckAttach.id)
            urlAttachment = `/checklist/value/attachment/${this.checklistValue.id}/${ckAttach.id}`;
          else
            urlAttachment = `/checklist/value/attachment/${this.checklistValue.id}`;

          this.$apiChecklist
            .request({
              url: urlAttachment,
              method: "GET",
              responseType: "arraybuffer", //important
            })
            .then((response) => {
              const base64 = btoa(
                new Uint8Array(response.data).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              );
              ckAttach.attachment = `data:image/png;charset=utf-8;base64,${base64}`;
            })
            .catch((error) => {
              console.log(error);
              console.log(error.response.data.errors);
              if (error.response.status == 400) {
                console.log(error.response.data.errors);
              }
            });
        }
      });
    },
    openImage(attachment) {
      this.fullscreenAttachment = attachment;
      this.$refs.fullscreenSidebar.open();
    },
  },
};
</script>
<style scoped>
.imagem {
  margin-left: 40%;
}
.iconPendencies {
  position: relative;
  color: #fd5d93;
}
.danger {
  color: #fd5d93;
}
.hasPendency {
  border-color: #fd5d93 !important;
}
</style>
